import { graphql } from 'react-relay';

import { type nftSecondaryMarketModalQuery as QueryType } from './__generated__/nftSecondaryMarketModalQuery.graphql.ts';

export type NftSecondaryMarketModalQueryType = QueryType;

export const nftSecondaryMarketModalQuery = graphql`
    query nftSecondaryMarketModalQuery(
        $nftItemId: String!
        $userId: String!
        $fetchSplitName: Boolean = false
        $fetchUser: Boolean = true
    ) {
        viewer {
            nftItems(nftIds: [$nftItemId]) {
                ...NftSecondaryMarketModal_nftItem
            }
            ...useMarketContext_viewer
            ...NftSecondaryMarketModalContent_viewer
        }
    }
`;
